<div [innerHTML]="getText"></div>
